/**
 *
 * SurveyConfigPreview
 *
 */

import React, { Fragment } from "react"
import { Button } from "antd"
import { Icon } from "@ant-design/compatible"
import { get, filter } from "lodash"
// import PropTypes from 'prop-types';
import "./index.less"
import { LeftOutlined, RightOutlined } from "@ant-design/icons"

/* eslint-disable react/prefer-stateless-function */
class SurveyConfigPreview extends React.Component {
  state = {
    startQuestion: 0,
    numberOfQuestions: 0,
  }

  componentDidMount = () => {
    const { questions } = this.props

    this.setState({ numberOfQuestions: questions.length })
  }

  renderCells = (color) => {
    const cells = []
    let i = this.renderOneQuestion().id_question_type === 3 ? 0 : 1
    while (i <= 5) {
      cells.push(
        <div style={{ borderColor: color, color }} key={i}>
          {i}
        </div>
      )
      i++
    }

    return cells
  }

  renderOneQuestion = () => {
    const { questions } = this.props
    const filterOnlyLikert = questions // filter(questions, item => item.id_question_type === 1);

    if (filterOnlyLikert.length) {
      const { startQuestion } = this.state

      return filterOnlyLikert[startQuestion]
    }

    return {}
  }

  renderBar = () => {
    const { startQuestion } = this.state
    const bar = []

    let i = 1
    while (i < this.state.numberOfQuestions) {
      bar.push(
        <div
          // className={ i <= startQuestion ? 'active' : ''}
          style={{
            backgroundColor: i <= startQuestion ? this.props.color_button : "",
          }}
          key={i}
        />
      )
      i++
    }

    return bar
  }

  render() {
    const { background_image } = this.props

    return (
      <div
        className="survey-config-view-questions"
        style={{ backgroundColor: this.props.background_color }}>
        <div style={{ color: this.props.color_text_question, zIndex: 1 }}>
          {this.props.display_number &&
            `${get(this.renderOneQuestion(), "order", "0")}.`}{" "}
          {get(this.renderOneQuestion(), "title", "")}
        </div>
        <div style={{ zIndex: 1 }}>
          {// Verificaremos si es diferente a tipo cualitativa
          this.renderOneQuestion().id_question_type != 2 ? (
            <Fragment>
              <div>
                Marca un número entre el{" "}
                {this.renderOneQuestion().id_question_type === 3 ? 0 : 1} y 5.
              </div>
              <div
                className="survey-config-view-questions-bar"
                style={{
                  borderColor: this.props.color_text_likert,
                  gridTemplateColumns:
                    this.renderOneQuestion().id_question_type === 3
                      ? "1fr 1fr 1fr 1fr 1fr 1fr"
                      : null,
                }}>
                {this.renderCells(this.props.color_text_likert)}
              </div>
              <div className="survey-config-view-questions-footer">
                <span>{this.props.likert_text_left}</span>
                <span>{this.props.likert_text_center}</span>
                <span>{this.props.likert_text_right}</span>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <textarea
                className="textAreaSurveyAnswer"
                name="textArea"
                placeholder="Escribe la respuesta aquí..."
                style={{ resize: "none", width: 640 }}
              />
            </Fragment>
          )}
        </div>
        <div className="survey-config-view-questions-actions">
          <Button
            disabled={!this.state.startQuestion}
            size="large"
            onClick={() =>
              this.setState({ startQuestion: --this.state.startQuestion })
            }>
            <LeftOutlined style={{ height: 15 }} />{" "}
            <span style={{ height: "auto" }}>Anterior</span>
          </Button>
          <Button
            disabled={
              this.state.numberOfQuestions === this.state.startQuestion + 1
            }
            size="large"
            type="primary"
            style={{ backgroundColor: this.props.color_button }}
            onClick={() =>
              this.setState({ startQuestion: ++this.state.startQuestion })
            }>
            Siguiente <RightOutlined style={{ height: 15 }} />
          </Button>
        </div>
        {this.props.display_progress_bar && (
          <div
            className="survey-config-view-questions-progress"
            style={{
              gridTemplateColumns: `repeat(${this.state.numberOfQuestions -
                1}, 1fr)`,
            }}>
            {this.renderBar()}
          </div>
        )}
        <div
          className="logo-top-right"
          style={{ zIndex: 1, opacity: this.props.company_logo_opacity / 100 }}>
          <img src={this.props.company_logo} />
        </div>
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center 0px",
            left: 0,
            top: 0,
            backgroundColor: "#FFF",
            backgroundImage: `url(${background_image})`,
            opacity: this.props.background_image_opacity / 100,
          }}
        />
      </div>
    )
  }
}

SurveyConfigPreview.propTypes = {}

export default SurveyConfigPreview
